module.exports = __webpack_public_path__ + "img/max4.332e1db7.jpg";